import { render, staticRenderFns } from "./ChangeControlDlg.vue?vue&type=template&id=8bf56a6e"
import script from "./ChangeControlDlg.vue?vue&type=script&lang=js"
export * from "./ChangeControlDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports